import SEOHead from "../lib/SEOHead";

/**
 * Hero for interior pages.
 * - If `image` is provided (a self-hosted photo that actually depicts the
 *   hotel or a verified subject), it's used as a dimmed background photo.
 * - If `image` is null/undefined (e.g. an audience page about Truman Lake
 *   where we don't have a verified photo of the lake), we render a styled
 *   brand pattern instead of a photo. This keeps the "no misleading images"
 *   rule intact.
 */
export default function PageHero({
  eyebrow,
  title,
  intro,
  image,
  metaTitle,
  metaDesc,
}) {
  return (
    <>
      <SEOHead title={metaTitle || title} description={metaDesc || intro} />
      <section
        className="relative bg-[#1A1A1A] text-white overflow-hidden"
        data-hero-dark="true"
        data-testid="page-hero"
      >
        <div className="absolute inset-0" aria-hidden="true">
          {image ? (
            <>
              <img
                src={image}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover opacity-45"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30" />
            </>
          ) : (
            <>
              <div className="absolute inset-0 bg-gradient-to-br from-[#B94A15]/70 via-[#1A1A1A] to-[#1A1A1A]" />
              <div
                className="absolute inset-0 opacity-50"
                style={{
                  backgroundImage:
                    "radial-gradient(55% 50% at 18% 25%, rgba(232,93,38,0.5) 0%, rgba(232,93,38,0) 60%), radial-gradient(45% 40% at 82% 78%, rgba(245,185,141,0.28) 0%, rgba(245,185,141,0) 60%)",
                }}
              />
              <div
                className="absolute inset-0 opacity-[0.06]"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #FDFBF7 1px, transparent 1px), linear-gradient(to bottom, #FDFBF7 1px, transparent 1px)",
                  backgroundSize: "40px 40px",
                }}
              />
            </>
          )}
        </div>
        <div className="relative wb-container py-20 md:py-28">
          {eyebrow && (
            <div className="wb-eyebrow text-[#FF9666]">{eyebrow}</div>
          )}
          <h1 className="wb-h1 text-white mt-4 max-w-3xl">{title}</h1>
          {intro && (
            <p className="wb-body text-white/90 mt-5 max-w-2xl">{intro}</p>
          )}
        </div>
      </section>
    </>
  );
}
